import Vue from 'vue';
import { mapGetters } from 'vuex'

Vue.component('CollapsibleHeader', {
  template: `
    <div v-bind:class="{ 'collapsible__header': isCollapsible }" @click="toggle">
      <slot></slot>
    </div>
  `,
  methods: {
    toggle: function() {
      if(this.$parent.toggle && typeof(this.$parent.toggle) === 'function' && this.isCollapsible) {
        this.$parent.toggle();
      }
    }
  },
  computed: {
    isCollapsible: function() {
      if(!this.$parent.isCollapsible) {
        return false;
      }
      return this.$parent.isCollapsible;
    }
  }
});

Vue.component('CollapsibleBody', {
  template: `
    <div v-bind:class="{ 'collapsible__body': isCollapsible, 'collapsible__body--absolute': (positioned == 'absolute' && isCollapsible && !reload), 'collapsible__body--reload': (isCollapsible && reload) }" ref="collapsibleBody" v-bind:style="styles">
      <div v-bind:class="{ 'collapsible__body-holder': isCollapsible }" >
        <slot></slot>
      </div>
    </div>
  `,
  data: function() {
    return {
      height: 0,
      reload: false,
      styles: {}
    };
  },
  methods: {
    calculateHeight: function() {

      if(!this.isCollapsible) {
        return;
      }

      this.height = this.$refs.collapsibleBody.scrollHeight;
      this.generateStyles();
    },
    generateStyles: function() {

      if(!this.isCollapsible) {
        this.styles = {};
      }

      this.styles = {
        'max-height': `${this.isOpened ? this.height : 0 }px`,
      };

      this.reload = false;

    },
  },
  watch: {
    currentMediaQueryName: function() {
      this.calculateHeight();
    },
    isOpened: function() {
      this.calculateHeight();
    }
  },
  computed: {
    ...mapGetters({
      currentMediaQueryName: 'mediaqueries/currentMediaQuery'
    }),

    isCollapsible: function() {
      if(!this.$parent.isCollapsible) {
        return false;
      }
      return this.$parent.isCollapsible;
    },
    isOpened: function() {
      if(!this.$parent.isOpened) {
        return false;
      }
      return this.$parent.isOpened;
    },
    positioned: function() {
      if(!this.$parent.position) {
        return 'relative';
      }
      return this.$parent.position;
    }
  }
});

Vue.component('Collapsible', {
  template: `
    <div :id="id" v-bind:class="{'collapsible': isCollapsible, 'collapsible--opened': isOpened }">
      <slot></slot>
    </div>
  `,
  props: {
    id: {
      type: String,
      required: true
    },
    validMediaQueries: {
      type: Array,
    },
    currentMediaQuery: {
      type: String,
      required: true
    },
    onClick: {
      type: Function
    },
    position: {
      type: String,
      required: false
    }
  },
  data: function() {
    return {
      isOpened: false
    }
  },
  watch: {
    currentMediaQuery: function(value) {
      if(!this.isCollapsible) {
        this.isOpened = false;
      }
    }
  },
  methods: {
    toggle: function() {
      if(this.isCollapsible) {
        this.isOpened = !this.isOpened;
      }
      if(this.onClick && typeof(this.onClick) == 'function') {
        this.onClick(this);
      }
    }
  },
  computed: {
    isCollapsible: function() {
      if(!this.validMediaQueries) {
        return true;
      }
      return this.validMediaQueries.includes(this.currentMediaQuery);
    }
  },
});



// WEBPACK FOOTER //
// ./components/collapsible/collapsible.js